import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, FileStoreProcess, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catFormatosDeVenta } from "../Categorias y Estados/catFormatosDeVenta";
import { catGruposProducto } from "../Categorias y Estados/catGruposProducto";
import { catTiposCodigoBarra } from "../Categorias y Estados/catTiposCodigoBarra";



const columns = () =>
(
    {
        c_producto_id: new EntityColumn<string>({ name: 'c_producto_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Producto ID' }),
        c_fileprocess_id: new EntityColumn<string>({ name: 'c_fileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Fileprocess Id' }),
        vc_codigoproducto: new EntityColumn<string>({ name: 'vc_codigoproducto', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Código interno' }),
        vc_codigobarras: new EntityColumn<string>({ name: 'vc_codigobarras', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Código de barras' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_nombrecorto: new EntityColumn<string>({ name: 'vc_nombrecorto', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Nombre corto' }),
        vc_GTIN8: new EntityColumn<string>({ name: 'vc_GTIN8', type: 'varchar', length: 8, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'GTIN8' }),
        vc_EAN13: new EntityColumn<string>({ name: 'vc_EAN13', type: 'varchar', length: 13, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'EAN13' }),
        vc_UPCA: new EntityColumn<string>({ name: 'vc_UPCA', type: 'varchar', length: 12, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'UPCA' }),
        vc_DUN14: new EntityColumn<string>({ name: 'vc_DUN14', type: 'varchar', length: 14, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'DUN14' }),
        vc_GS1128: new EntityColumn<string>({ name: 'vc_GS1128', type: 'varchar', length: 128, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'GS1-128' }),
        n_precio: new EntityColumn<number>({ name: 'n_precio', type: 'decimal', length: 14, scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Precio' }),
        vc_peso: new EntityColumn<string>({ name: 'vc_peso', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Peso' }),
        vc_medida: new EntityColumn<string>({ name: 'vc_medida', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Medida' }),
        vc_unidadesxbulto: new EntityColumn<string>({ name: 'vc_unidadesxbulto', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Unidades' }),
        c_tipocodigobarra_id: new EntityColumn<string>({ name: 'c_tipocodigobarra_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tipo' }),
        vc_gruposproducto: new EntityColumn<string[]>({ name: 'vc_gruposproducto', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Grupos', isArray: true }),
        vc_formatosproducto: new EntityColumn<string[]>({ name: 'vc_formatosproducto', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Formatos', isArray: true }),
        vc_fotoguid: new EntityColumn<string>({ name: 'vc_fotoguid', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fotoguid' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        prdc_brwStandard: { name: 'prdc_brwStandard', keyMappings: { c_producto_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'FileStoreProcess': {
            name: 'FileStoreProcess',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new FileStoreProcess(client, parentKeys)
        },

        'TiposCodigoBarra': {
            name: 'TiposCodigoBarra',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposCodigoBarra(client, parentKeys)
        },

        'GruposProducto': {
            name: 'GruposProducto',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catGruposProducto(client, parentKeys)
        },

        'FormatosDeVenta': {
            name: 'FormatosDeVenta',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catFormatosDeVenta(client, parentKeys)
        }
    }
)

export class ProductosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Productos');
    }
}